import { useEffect, useState } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { SidebarModal } from '../../components/common/Sidebar/Sidebar';
import { SelectedPlan } from '../../components/common/VirtualOfficeSubscription/SelectedPlan';
import {
  dateDifferenceInDaysFromToday,
  globalPlans
} from '../../helpers/helperFunctions';
import { H3, P2 } from '../../styles/FontStyles';
import { useAppSelector } from '../../app/hooks';
import { Button, Flexed, PageTitle } from '../../styles/GlobalComponents';
import { getUserTickets } from '../../slices/auth-slice';
import { useDispatch } from 'react-redux';
import { VirtualOfficeGrid } from '../../components/common/VirtualOfficeSubscription/VirtualOfficeGrid';
import { colors } from '../../styles/GlobalStyles';
import { VirtualOfficeBanner } from './VirtualOfficeBanner';

export const VirtualOffice = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(globalPlans()[0]);
  const [step, setStep] = useState(1);
  const { user } = useAppSelector((state) => state.settings);
  const { t } = useTranslation('settings');
  const dispatch = useDispatch();

  const date = user?.currentVirtualOfficeLicence?.dateEnd;

  const virtualOfficeEndDate = moment(date).format('Do of MMMM YYYY');

  const dateEnded = dateDifferenceInDaysFromToday(date) === 0;

  const isTrialLicense = user?.currentVirtualOfficeLicence.licenceId === null;

  useEffect(() => {
    dispatch(getUserTickets());
  }, [dispatch]);

  return (
    <div>
      <PageTitle>{t('virtual_office.title1')}</PageTitle>
      <VirtualOfficeBanner />
      <P2 mb='45' mt='5'>
        {t('virtual_office.text1')}
      </P2>

      <Flexed justifyCenter>
        <P2 mb='5' mt='5'>
          {t('virtual_office.text2')}
        </P2>
      </Flexed>

      {dateEnded ? (
        <Flexed justifyCenter>
          <H3 center>
            {t('virtual_office.not_active')}{' '}
            <span style={{ color: colors.error500 }}>
              {t('virtual_office.expired')}
            </span>
          </H3>
        </Flexed>
      ) : (
        <Flexed justifyCenter>
          <H3 center>
            {isTrialLicense && t('virtual_office.in_trial')}{' '}
            {t('virtual_office.banner.valid_until')} {virtualOfficeEndDate}
          </H3>
        </Flexed>
      )}

      <Flexed justifyCenter>
        <P2 mb='5' mt='5'>
          (
          {`${dateDifferenceInDaysFromToday(
            user?.currentVirtualOfficeLicence?.dateEnd
          )}`}{' '}
          {t('virtual_office.banner.days_left')})
        </P2>
      </Flexed>

      <H3 mb='20' mt='40'>
        {t('virtual_office.title2')}
      </H3>
      <P2 mb='25' mt='5'>
        {t('virtual_office.text3')}
      </P2>
      <P2 mb='20'>{t('virtual_office.text4')}</P2>
      <VirtualOfficeGrid
        setSelected={setSelected}
        setIsOpen={setIsOpen}
        setStep={setStep}
      />

      <SidebarModal
        isOpen={isOpen}
        setOpen={setIsOpen}
        title={t('virtual_office.backoffice_subscription')}
        sidebarWidth={'600px'}>
        <SelectedPlan
          selected={selected}
          setSelected={setSelected}
          step={step}
          setStep={setStep}
        />
      </SidebarModal>
    </div>
  );
};
